"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3154],{

/***/ 53154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(26628);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./components/header/header.module.scss
var header_module = __webpack_require__(44032);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/header/Menu/RenderIcon.tsx






var RenderIcon = function(param) {
    var item = param.item, withIcons = param.withIcons;
    var domain = (0,es/* useSelector */.v9)(function(state) {
        return state.general.domain;
    });
    var dbName = (0,es/* useSelector */.v9)(function(state) {
        return state.general.dbName;
    });
    var diffProductImage = item && item.locale_image ? "".concat(dbName, "/storage/").concat(domain, "/").concat(item.locale_image) : "".concat(dbName, "/vendor/webkul/ui/assets/images/flag_").concat(item.code, ".svg");
    if (withIcons) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (header_module_default()).menu__icon,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: (0,helper/* domainUrl */.HJ)(diffProductImage),
                alt: "".concat(item && item.name, " language"),
                // placeholder="blur"
                height: 16,
                width: 20
            })
        });
    }
    return null;
};
/* harmony default export */ var Menu_RenderIcon = (RenderIcon);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/header/Menu/RenderLinks.tsx







var RenderLink = function(param) {
    var item = param.item, content = param.content, onClick = param.onClick, onCloseWindow = param.onCloseWindow;
    if (item.slug) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: utils/* url.category */.HQ.category(item),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (header_module_default()).menu__li__a
            }, item.props), {
                onClick: function() {
                    onClick(item);
                    onCloseWindow && onCloseWindow();
                },
                children: content
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (header_module_default()).menu__li__a,
        href: "/".concat(item.code),
        onClick: function(e) {
            e.preventDefault();
            onClick(item);
            onCloseWindow && onCloseWindow();
        },
        children: content
    });
};
/* harmony default export */ var RenderLinks = (/*#__PURE__*/(0,react.memo)(RenderLink));

;// CONCATENATED MODULE: ./components/header/Menu/RenderSubMenu.tsx




var RenderSubMenu = function(param) {
    var item = param.item, onClick = param.onClick;
    if (item.children && item.children.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (header_module_default()).menu__submenu,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Menu, {
                items: item.children,
                onClick: onClick
            })
        });
    }
    return null;
};
/* harmony default export */ var Menu_RenderSubMenu = (/*#__PURE__*/(0,react.memo)(RenderSubMenu));

;// CONCATENATED MODULE: ./components/header/Menu/RenderMenuItem.tsx







var RenderMenuItem = function(param) {
    var item = param.item, index = param.index, withIcons = param.withIcons, onClick = param.onClick, onCloseWindow = param.onCloseWindow;
    var icon = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_RenderIcon, {
                item: item,
                withIcons: withIcons
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((header_module_default())["dropdown-submenu-items"]),
                children: item.title || item.name
            }),
            item.children && item.children.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedRight6x9Svg */.EO, {
                className: (header_module_default()).menu__arrow
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (header_module_default()).menu__li,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RenderLinks, {
                item: item,
                content: icon,
                onClick: onClick,
                onCloseWindow: onCloseWindow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_RenderSubMenu, {
                item: item,
                onClick: onClick
            })
        ]
    }, index);
};
/* harmony default export */ var Menu_RenderMenuItem = (/*#__PURE__*/(0,react.memo)(RenderMenuItem));

;// CONCATENATED MODULE: ./components/header/Menu/index.tsx





var Menu = function(param) {
    var layout = param.layout, withIcons = param.withIcons, items = param.items, onClick = param.onClick, onCloseWindow = param.onCloseWindow;
    var classes = classnames_default()("".concat((header_module_default()).menu, " ").concat((header_module_default())["menu--layout--".concat(layout)]), withIcons && (header_module_default())["menu--with-icons"]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: classes,
        children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_RenderMenuItem, {
                item: item,
                index: index,
                withIcons: withIcons,
                onClick: onClick,
                onCloseWindow: onCloseWindow
            }, index);
        })
    });
};
/* harmony default export */ var header_Menu = (Menu);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/header/Dropdown/Button.tsx
/* provided dependency */ var process = __webpack_require__(34155);








var TopBarDropDownBtn = function(param) {
    var classname = param.classname, currency = param.currency, handleButtonClick = param.handleButtonClick, local = param.local, newLocal = param.newLocal, open = param.open, current = param.current, currencyList = param.currencyList, itemsLength = param.itemsLength, pageProps = param.pageProps;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(pageProps && ((ref = pageProps.topBarLocales) === null || ref === void 0 ? void 0 : ref[0].name)), languageName = ref1[0], setLanguageName = ref1[1];
    var domain = (0,es/* useSelector */.v9)(function(state) {
        return state.general.domain;
    });
    // const dbName = useSelector((state: IState) => state.general.dbName);
    var locale = (0,es/* useSelector */.v9)(function(state) {
        return state.locale;
    });
    var curr = currencyList === null || currencyList === void 0 ? void 0 : currencyList.find(function(item) {
        return (item === null || item === void 0 ? void 0 : item.code) == current;
    });
    var dbName = (pageProps === null || pageProps === void 0 ? void 0 : pageProps.dbName) || process.env.domainName;
    var diffProductImage = local && local.locale_image ? "".concat(dbName, "/storage/").concat((pageProps === null || pageProps === void 0 ? void 0 : pageProps.domain) || domain, "/").concat(local.locale_image) : "".concat(dbName, "/vendor/webkul/ui/assets/images/flag_").concat(pageProps === null || pageProps === void 0 ? void 0 : pageProps.locale, ".svg");
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        setLanguageName(// @ts-ignore
        router.asPath === "/" ? pageProps && ((ref1 = (ref = pageProps.topBarLocales) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item.code === newLocal;
        })) === null || ref1 === void 0 ? void 0 : ref1.name) : (ref3 = (ref2 = locale.list) === null || ref2 === void 0 ? void 0 : ref2.find(function(item) {
            return item.code === newLocal;
        })) === null || ref3 === void 0 ? void 0 : ref3.name);
    }, [
        newLocal
    ]);
    var renderImage = function() {
        if (currency) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (header_module_default())["lang-mobile-img_level_1"],
                children: curr === null || curr === void 0 ? void 0 : curr.symbol
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: (0,helper/* domainUrl */.HJ)(diffProductImage),
                    alt: "".concat(local && local.name, " language"),
                    height: 16,
                    width: 20
                })
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: "".concat((header_module_default())["topBar-dropdown__btn"], " ").concat(classname),
        type: "button",
        onClick: handleButtonClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (header_module_default())["lang-name-image"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((header_module_default())["lang-name"], " ").concat(currency),
                        children: currency && (curr === null || curr === void 0 ? void 0 : curr.name) || languageName
                    }),
                    renderImage()
                ]
            }),
            itemsLength && itemsLength > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {
                className: open && "".concat((header_module_default()).rotT_fms)
            })
        ]
    });
};
/* harmony default export */ var Button = (TopBarDropDownBtn);

// EXTERNAL MODULE: ./context/index.tsx
var context = __webpack_require__(92726);
;// CONCATENATED MODULE: ./components/header/Dropdown/Dropdown.tsx








var Dropdown = function(param) {
    var _forWhat = param.forWhat, forWhat = _forWhat === void 0 ? "currency" : _forWhat, current = param.current, items = param.items, _withIcons = param.withIcons, withIcons = _withIcons === void 0 ? false : _withIcons, locale = param.locale, newLocal = param.newLocal, onClick = param.onClick;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var currencyList = (0,es/* useSelector */.v9)(function(state) {
        return state.rate.list;
    });
    var wrapperRef = (0,react.useRef)(null);
    var setWrapperRef = function(node) {
        wrapperRef.current = node;
    };
    var handleOutsideClick = function(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setOpen(function() {
                return false;
            });
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    var handleButtonClick = function() {
        setOpen(function() {
            return !open;
        });
    };
    var handleItemClick = function() {
        setOpen(function() {
            return false;
        });
    };
    var local = null;
    var classes = classnames_default()("".concat((header_module_default())["topBar-dropdown"]), open && (header_module_default())["topBar-dropdown--opened"]);
    var openDropdownLanguageClasses = classnames_default()("".concat((header_module_default())["topBar-dropdown__body"]), open && (header_module_default()).newclass);
    if (locale && locale.list.length > 0 && newLocal) {
        var ref1;
        local = (ref1 = locale.list) === null || ref1 === void 0 ? void 0 : ref1.find(function(item) {
            return item.code === newLocal;
        });
    }
    var filteredItems = items;
    switch(forWhat){
        case "language":
            filteredItems = items === null || items === void 0 ? void 0 : items.filter(function(e) {
                return e.code != (locale === null || locale === void 0 ? void 0 : locale.code);
            });
            break;
        case "currency":
            filteredItems = filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.filter(function(e) {
                return e.code != (local === null || local === void 0 ? void 0 : local.code);
            });
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        ref: setWrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* PropsConsumer */.L, {
                children: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        itemsLength: items && items.length,
                        handleButtonClick: handleButtonClick,
                        local: local,
                        newLocal: newLocal,
                        currencyList: currencyList,
                        current: current,
                        open: open,
                        classname: items && items.length > 1 && forWhat === "language" ? (header_module_default()).lang_dropdown : (!items || items.length <= 1) && forWhat === "language" ? "".concat((header_module_default())["null-icon-fms"], " ").concat((header_module_default()).lang_dropdown) : false,
                        currency: forWhat === "currency" ? "currency" : false,
                        pageProps: props
                    });
                }
            }),
            items && items.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: openDropdownLanguageClasses,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Menu, {
                    onCloseWindow: handleItemClick,
                    layout: "topBar",
                    withIcons: withIcons,
                    items: filteredItems,
                    onClick: onClick,
                    symbol: items[0].symbol
                })
            }) : ""
        ]
    });
};
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);


/***/ })

}]);